import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from "jquery";
import Login from "./pages/examples/Login.jsx";
import AcessClassRoom from "./pages/examples/AcessClassRoom.jsx";
import AcessPublicClassRoom from "./pages/examples/AcessPublicClassRoom.jsx";
import AdminLayout from "./../layouts/Admin.jsx"; 
import { Alert } from 'reactstrap';
import ConnectionStatus from '../components/ConnectionStatus'; 

import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Main extends React.Component {

  	constructor(props){

    	super(props);
		this.state = {
			...this.state,
			isOnline: navigator.onLine,
			showConnectionAlert: false,
			connectionMessage: '',
			alertType: 'success'
		};
		
		this.loginSuccess = this.loginSuccess.bind(this);
		window.main = this;

  	}
  	
   	loginSuccess(session,user){ 

		console.log('session'+session);
		console.log('user');
		console.log(user);

  		sessionStorage.setItem('session',session);
		sessionStorage.setItem('userId',user.id);
		  
		cookies.set('session',session,{path:'/'});
		cookies.set('userId',user.id,{path:'/'});

		this.props.setAppState({session:session,userId:user.id,user:user});
		//console.log(user);
       
  	}

 	componentDidMount(){
		 
		$("head").append('<link rel="icon" href="'+sessionStorage.getItem('backend')+window.app.state.confs.favicon+'"></link>');

		// Adicione os listeners de conexão
		window.addEventListener('online', this.handleOnline);
		window.addEventListener('offline', this.handleOffline);
		
		// Monitore as requisições da API
		this.setupApiMonitoring();
	}

	componentWillUnmount() {
		window.removeEventListener('online', this.handleOnline);
		window.removeEventListener('offline', this.handleOffline);
	}

	handleOnline = () => {
		this.setState({ 
			isOnline: true,
			showConnectionAlert: true,
			connectionMessage: 'Conexão restabelecida!',
			alertType: 'success'
		});

		// Esconde o alerta após 3 segundos
		setTimeout(() => {
			this.setState({ showConnectionAlert: false });
		}, 3000);
	}

	handleOffline = () => {
		this.setState({ 
			isOnline: false,
			showConnectionAlert: true,
			connectionMessage: 'Sem conexão com a internet',
			alertType: 'danger'
		});
	}

	setupApiMonitoring = () => {
		// Monitora as requisições da API
		if (window.axios) {
			window.axios.interceptors.response.use(
				response => response,
				error => {
					if (!error.response && !navigator.onLine) {
						this.setState({
							showConnectionAlert: true,
							connectionMessage: 'Erro de conexão. Verifique sua internet.',
							alertType: 'warning'
						});
					}
					return Promise.reject(error);
				}
			);
		}
	}

	render() {

		const loginSuccess = this.loginSuccess; 
		console.log('Deu rende main');


		console.log('this.props.getAppState().session: '+this.props.getAppState().session);

		console.log('window.app.state.user:');
		console.log(window.app.state.user);

		console.log('this.props.user.preference:');
		console.log(this.props.user.preference);

		if(window.app.state.user !== undefined){

			console.log('window.app.state.user.preference');
			console.log(window.app.state.user.preference);

		}
		

  		return ( 
  				<React.Fragment>
					<ConnectionStatus /> 
					{this.state.showConnectionAlert && (
						<div style={{
							position: 'fixed',
							top: '20px',
							right: '20px',
							zIndex: 9999,
							minWidth: '300px'
						}}>
							<Alert 
								color={this.state.alertType}
								isOpen={this.state.showConnectionAlert}
								toggle={() => this.setState({ showConnectionAlert: false })}
							>
								<span className="alert-icon">
									<i className={`fas fa-${this.state.alertType === 'success' ? 'check' : 'exclamation'}-circle mr-2`}></i>
								</span>
								<span className="alert-text">{this.state.connectionMessage}</span>
							</Alert>
						</div>
					)}

  					<title>{window.app.state.confs.systemName}</title>

	  				<Router>
						{
							//Caso tenha session o storage
							(this.props.getAppState().session !== "" && window.app.state.user !== undefined) &&
							<React.Fragment>

								{

									(window.app.state.user.preference !== undefined) &&
									<React.Fragment>
										{/**/} 
											<Switch>
												<Route exact={true} path="/classenter/:classroom" render={ (props) => <AcessClassRoom {...props} {...{ loginSuccess }} /> }/>
												<Route exact={true} path="/sala/:classroom" render={ (props) => <AcessClassRoom {...props} {...{ loginSuccess }} /> }/>
												<Route path="*" render={props => <AdminLayout {...props} />} />
											</Switch>
										
									</React.Fragment>

								}
								
							</React.Fragment>

						}{
							//Caso o session no app esteja em branco, exibe a tela de login
							(this.props.getAppState().session === "" && window.app.state.user === undefined) &&
							<React.Fragment>
																 
								{/*	
								<AcessClassRoom {...{ loginSuccess }} />
									<Login {...{ loginSuccess }} />
								*/}
								
								<Switch>
									
									<Route exact={true} path="/confirm/:confirmCode" render={ (props) => <Login {...props} {...{ loginSuccess }} /> } />
									<Route path={["/publicclassenter/:classroom/:extra","/publicclassenter/:classroom"]} render={ (props) => <AcessPublicClassRoom {...props} {...{ loginSuccess }} /> } />
									
									<Route exact={true} path="/classenter/:classroom" render={ (props) => <AcessClassRoom {...props} {...{ loginSuccess }} /> } />

									<Route exact={true} path="/classenter/:classroom" render={ (props) => <AcessClassRoom {...props} {...{ loginSuccess }} /> } />
									<Route exact={true} path="/sala/:classroom" render={ (props) => <AcessClassRoom {...props} {...{ loginSuccess }} /> } />
									
									<Route exact={true} path="/" render={ (props) => <Login {...props} {...{ loginSuccess }} /> }/>
									<Route exact={true} path="/recoverpassword/:id" render={ (props) => <Login {...props} {...{ loginSuccess }} /> } />
									
									<Redirect to="/" /> 

								</Switch>
							</React.Fragment>
						 	

						}
					</Router>

				</React.Fragment>);

	}

}

export default connect(state =>({

	languages: state.language,
	translate: state.translate,
	accesslevel: state.accesslevel,
	permission: state.permission,
	user: state.user,
  
  }))(Main);